<template>
  <div class="gameplan">
    <div class="normal_box">
      <el-form :inline="true" ref="editFormRef" :model="params" label-position="left" label-width="182px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="需要场勘" prop="needVerify">
              <template slot="label"><span class="required-text">*</span>需要场勘</template>
              <el-radio-group class="item" v-model="params.needVerify">
                <el-radio v-for="item of radioList" :key="item.key" :label="item.value">{{item.key}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需要搭建" prop="needConstruct">
              <template slot="label"><span class="required-text">*</span>需要搭建</template>
              <el-radio-group class="item" v-model="params.needConstruct">
                <el-radio v-for="item of radioList" :key="item.key" :label="item.value">{{item.key}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需要使用SPR临促管理系统" prop="needSpr">
              <template slot="label"><span class="required-text">*</span>需要使用SPR临促管理系统</template>
              <el-radio-group class="item" v-model="params.needSpr">
                <el-radio v-for="item of radioList" :disabled="Object.keys(saveInfo).length>0" :key="item.key" :label="item.value">{{ item.key }}</el-radio >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需要转场" prop="needTransitions">
              <template slot="label"><span class="required-text">*</span>需要转场</template>
              <el-radio-group class="item" v-model="params.needTransitions" @change="needTransitionsChanged">
                <el-radio
                  v-for="item of radioList"
                  :key="item.key"
                  :label="item.value"
                  >{{ item.key }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="params.needSpr===1">
            <el-form-item class="input-width-sp" label="临促人员人数限制" prop="pgQtyLimit" ref="pgQtyLimitRef">
              <template slot="label"><span class="required-text" v-if="params.needSpr===1">*</span>临促人员人数限制
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="此处填写数量为单场活动（每售点每天计为一个场次）需投入临促人员人数上限">
                  <i  slot="reference" class="el-icon-question sp-icon"></i>
                </el-popover>
              </template>
              <el-input :disabled="Object.keys(saveInfo).length>0" type="number" min="0"  oninput="value=value.replace(/[^\d]/g,'')" v-model="params.pgQtyLimit" placeholder="请输入临促人员人数限制"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="params.needSpr===1">
            <el-form-item label="打卡/执行信息上传方式" >
              <template slot="label"><span class="required-text" v-if="params.needSpr===1">*</span>打卡/执行信息上传方式
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="打卡/执行信息上传方式：请选择打卡/执行信息上传方式，选”督导统一上传”，则督导以一组人为单位管理，进行打卡及销量上报执行；选“临促人员自行上传”，则以单人为单位管理，进行打卡及销量上报执行；">
                  <i  slot="reference" class="el-icon-question sp-icon"></i>
                </el-popover>
              </template>
              <el-select :disabled="Object.keys(saveInfo).length>0" v-model="params.needPerformance" placeholder="打卡/执行信息上传方式">
                <!-- <el-radio-group class="item" v-model="params.needConstruct">
                  <el-radio v-for="item of radioList" :key="item.key" :label="item.value">{{item.key}}</el-radio>
                </el-radio-group> -->
                <el-option  v-for="item of needPerformanceList" :key="item.key" :label="item.key" :value="item.value"></el-option>
                <!-- <el-option label="否" value="0"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item class="cross-item">
              <template slot="label"><span class="required-text">*</span>点位照片
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="请选择需要供应商在搭建及执行阶段上传的照片类型，所选照片类型在供应商端和临促执行工具中都将作为必填项要求供应商上传">
                  <i  slot="reference" class="el-icon-question sp-icon"></i>
                </el-popover>
              </template>
              <!-- <el-checkbox-group v-model="params.themeDecorateCodes" class="decorate-style">
                <el-checkbox  v-for="item of showDecorates" :key="item.decorateCode" :class="item.mandatory?'sp':''" :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
              </el-checkbox-group> -->
              <el-checkbox-group class="decorate-style" v-model="themeDecorateCodes" @change="handleDecorateCodesChange">
                <div class="decorate-style">
                  <el-checkbox  v-for="item of showDecoratesInner" :key="item.decorateCode" :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
                </div>
                <div class="decorate-style">
                  <el-checkbox  v-for="item of showDecoratesOuter" :key="item.decorateCode" :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
                </div>
                <div class="decorate-style">
                  <el-checkbox  v-for="item of showDecoratesOther" :key="item.decorateCode" :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
                </div>
                <div class="decorate-style">
                  <el-checkbox  v-for="item of showExecDecorates" :key="item.decorateCode" :disabled="item.mandatory" :label="item.decorateCode">{{item.decorateName}}</el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="input-width-sp" label="单场投入预算" prop="investUnit" ref="investUnitRef">
              <template slot="label"><span class="required-text">*</span>单场投入预算</template>
              <el-input type="number" :min="1" oninput="if(isNaN(value)){ value = parseFloat(value) }if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" v-model="params.investUnit" placeholder="请输入单场投入预算"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="input-width-sp" v-if="params.needTransitions==0" :label="`每${getUnits}执行活动天数`" prop="perExecDays" ref="perExecDaysRef">
              <template slot="label"><span class="required-text">*</span>每{{getUnits}}执行活动天数</template>
              <el-input type="number" :min="1" oninput="value=value.replace(/[^\d]/g,'')" v-model="params.perExecDays" placeholder="请输入活动天数"></el-input>
            </el-form-item>
            <el-form-item class="input-width-sp" v-else label="道具数量设置" prop="itemQuantity" ref="itemQuantityRef">
              <template slot="label"><span class="required-text">*</span>请设置道具数量</template>
              <el-input type="number" :min="1" oninput="value=value.replace(/[^\d]/g,'')" v-model="params.itemQuantity" placeholder="请设置道具数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提报售点要求">{{ pocRelateTypeDesc }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="themeConfig.pocRelateType===2" class="cross-item input-width-sp" label="最少关联售点设置" prop="pocCountMin">
              <template slot="label"><span class="required-text">*</span>最少关联售点设置</template>
              <el-input class="item" type="number" @blur="handleValidatePocCountMin" oninput="value=value.replace(/[^\d]/g,'')" :min="1" v-model="params.pocCountMin" placeholder="请输入售点数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="input-width-sp" :label="getAssignName" prop="assignList" ref="itemQuantityRef">
          <template slot="label"><span class="required-text">*</span>{{ getAssignName }}
            <el-popover
              placement="top-start"
              width="300"
              trigger="hover">
              <div>额度信息与需要转场有关：</div><br />
              <div>当选择需要转场时，用户填写额度信息即表示活动执行的场次数量，无额外换算；举例：假设当前用户为BUE分配的额度为10，即表示BUE下所有提报售点区域选择执行日期总和不超过10场</div><br />
              <div>当选择不需要转场时，用户填写额度信息对应活动执行的售点/街区数量，活动总场次计算依据为：售点街区数量*每售点/街区执行活动天数；举例：假设当前用户为BUE分配的额度为10，活动执行天数设定为3，则BUE分配的活动场次总数为30</div>
              <i  slot="reference" class="el-icon-question sp-icon"></i>
            </el-popover>
            <!-- <div class="el-form-title-select" v-if="isHQ">
              从
              <el-select v-model="validDetailKey" @change="handleSelectExecutorList" clearable placeholder="请选择">
                <div>
                  <el-option 
                    v-for="(item,key) in validDetail" 
                    :key="key" 
                    :label="item.styleName" 
                    :value="key">
                  </el-option>
                </div>
              </el-select>
              复制
            </div> -->
          </template>
          <el-select v-model="assignList" @change="handleChangeAssignList" multiple collapse-tags clearable placeholder="请选择">
            <div v-if="assignCodeList.length>0">
              <el-option 
                v-for="item in assignCodeList" 
                :key="item.orgCode" 
                :label="getName(item.orgName)" 
                :value="item.orgCode">
              </el-option>
            </div>
          </el-select>
          <span v-if="params.needTransitions===0">总{{getUnits}}：{{getAllAssignQty|toThousandslsFilter()}}&ensp; &ensp;</span>
          <span>总执行天数：{{getAssignSum|toThousandslsFilter()}} &ensp; &ensp;</span>
          <span v-if="isBU">执行人：{{ this.userInfo.clientName }}</span>
        </el-form-item>
        <div class="config-detail-bu">
          <div class="assign-box" >
            <el-form v-for="item of assignInfoList" :rules="assignRules" :model="item" :key="item.orgName" ref="assignFormRef" hide-required-asterisk @submit.native.prevent>
              <el-form-item v-if="assignList.indexOf(item.orgCode)!==-1">
                <template slot="label">
                  <div class="assign-title-box">
                    <div><span class="required-text">*</span>{{getName(item.orgName)}}</div>
                    <div v-if="isHQ" class="assign-title-delete"><i @click="handleDeleteAssign(item)" class="el-icon-delete"></i></div>
                  </div>
                </template>
                <div class="assign-detail">
                  <el-input type="number" @change="(...val)=>handleChangeAssignQty(item,...val)" oninput="value=value.replace(/[^\d]/g,'')" :min="getMinAssign(item)" class="item" v-model="item.assignQty" placeholder="请输入分配额度"></el-input>
                  <el-select class="assign-executor" v-if="assignList.indexOf(item.orgCode)!==-1&&isHQ" v-model="item.executorCodeList" @change="handleSelectExecutor(item)" multiple collapse-tags clearable placeholder="请选择">
                    <div v-if="item.m3List.length>0">
                      <el-option 
                        v-for="person in item.m3List" 
                        :key="person.employeeCode" 
                        :label="getName(person.clientName)" 
                        :value="person.employeeCode">
                      </el-option>
                    </div>
                  </el-select>
                </div>
                <div class="font-red" v-if="Object.keys(saveInfo).length===0">执行天数： {{ getAssignQty(item.assignQty)|toThousandslsFilter() }} </div>
                <div class="assign-num-box" v-else>
                  <div> 原额度：{{  item.saveAssignQty |toThousandslsFilter() }} <span style="display:inline-block;margin-left:10px" :class="getDifferenceValue(item.assignQty,item.saveAssignQty)>0?'color-green':'color-red'" v-if="item.saveAssignQty&&getDifferenceValue(item.assignQty,item.saveAssignQty)!==0">{{ (getDifferenceValue(item.assignQty,item.saveAssignQty)>0?'+':'') + getDifferenceValue(item.assignQty,item.saveAssignQty)}}</span></div>
                  <div v-if="isHQ"> 已下发：{{ getNextAssignQty(item.regionAssignList,item.submitCountQty) |toThousandslsFilter()}}</div>
                  <div v-if="(isBU||isRegion)"> 已提报：{{ item.submitCountQty |toThousandslsFilter() }}</div>
                </div>
              </el-form-item>
              <!-- <el-form-item prop="executor" v-if="assignList.indexOf(item.orgCode)!==-1&&isHQ">
                <template slot="label"><span class="required-text">*</span>执行人</template>
                  <el-select v-model="item.executorCodeList" @change="handleSelectExecutor(item)" multiple collapse-tags clearable placeholder="请选择">
                    <div v-if="item.m3List.length>0">
                      <el-option 
                        v-for="person in item.m3List" 
                        :key="person.employeeCode" 
                        :label="getName(person.clientName)" 
                        :value="person.employeeCode">
                      </el-option>
                    </div>
                  </el-select>
              </el-form-item> -->
            </el-form> 
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapState } from 'vuex'
export default {
  props: {
    configInfo:{ type: Object, default: () => { } },
    itemKey:{ type: String, default: '' },
    themeChannelCode:{ type: String, default: '' },
    themeId:{ type: String, default: ''},
    validDetail:{ type: Object, default: () => { } }
  },
  data() {
    var validatePocCountMin = (rule, value, callback) => {
      if(Number(value)<1){
        return callback(new Error('最小售点数需大于等于1'));
      }else {
        callback()
      }
    };
    var validateAssignList = (rule, value, callback) => {
      if(value.length===0){
        return callback(new Error('请选择分配信息'));
      }else {
        callback()
      }
    };
    var validatePgQtyLimit = (rule, value, callback) => {
      console.log(value);
      if(!value){
        return callback(new Error());
      }else {
        callback()
      }
    };
    return {
      assignList:[],
      assignCodeList:[],
      assignInfoList:[],
      themeConfig:{},
      saveInfo:{},
      themeExecDecorates:[],
      themeDecorateCodes:[],
      showDecorates:[],
      showDecoratesInner:[],
      showDecoratesOuter:[],
      showDecoratesOther:[],
      showExecDecorates:[],
      params: {
        needVerify: 1,
        needConstruct: 1,
        needSpr: 1,
        needSupervisor: 1,
        needTransitions:1,
        needPerformance:null,
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        pgQtyLimit:'',
        investUnit:'',
        itemQuantity:'',
        perExecDays:'',
      },
      themeDetail:{},
      assignRules: {
        assignQty: [{ required: true, message: '请输入配额', trigger: 'blur' }],
        executor: [{ required: true, message: '请选择执行人', trigger: 'blur' }]
      },
      radioList: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      needPerformanceList: [
        { key: '督导统一上传', value: 1 },
        { key: '临促人员自行上传', value: 0 },
      ],
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      saveSubAssignList:[],
      employeeLevel:'',
      showError:false,
      btnType:'',
      //cityPoolList:[],
      showSaveAssignList:false,
      themeDecorates:[],
      validDetailList:[],
      validDetailKey:''
    }
  },
  computed:{
     ...mapGetters(['userInfo']),
     ...mapState({
      buList: state => state.gameplan.buList,
      regionList: state => state.gameplan.regionList,
      areaList: state => state.gameplan.areaList,
      regionOrgList: state => state.gameplan.regionOrgList,
      decorateMap: state => state.gameplan.decorateMap,
      execDecorateMap: state => state.gameplan.execDecorateMap,
      constructDecorateMap: state => state.gameplan.constructDecorateMap,
      decorateMap: state => state.gameplan.decorateMap,
    }),
     pocRelateTypeDesc () {
      if (this.themeConfig.pocRelateType === 0) {
        return '当前活动形式无需执行售点'
      } else if (this.themeConfig.pocRelateType === 1) {
        return '当前活动形式需要单售点执行'
      } else if (this.themeConfig.pocRelateType === 2) {
        return '当前活动形式需要多售点执行'
      } else {
        return ''
      }
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getAssignName(){
      if(this.isHQ){
        return 'BU额度配置'
      }else if(this.isBU){
        return '销售大区额度配置'
      }else {
        return '销售大区额度配置'
      }
    },
    getUnits(){
      let key = this.themeConfig.pocRelateType+''
      let units = '街区'
      switch (key) {
        case '0':
          units = '活动地点'
          break;
          case '1':
          units = '售点'
          break;
        default:
        units = '街区'
          break;
      }
      return units
    },
    getAllAssignQty(){
       let assignQty = this.assignInfoList.reduce((pre,item)=>{
        return pre + Number(item.assignQty)
      },0)
      return assignQty
    },
    getAssignSum(){
      return (this.params.needTransitions===1?this.getAllAssignQty:Number(this.getAllAssignQty)*Number(this.params.perExecDays))
    }
  },
  watch:{
    params:{
      handler:function(cur){
        this.submitData()
      },
      deep:true
    },
    assignInfoList:{
      handler:function(cur){
        this.submitData()
      },
      deep:true
    },
    assignList(){
      this.submitData()
    }
  },
  created() {
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeConfig =  this.configInfo.themeConfig
    this.saveInfo = this.configInfo.saveInfo || {}
    const constructDecoratekey = Object.keys(this.constructDecorateMap).filter(key =>{
      return this.itemKey.startsWith(key)
    })
    const constructDecorateCodes = this.constructDecorateMap[constructDecoratekey[0]].split('|')
    this.showDecorates = constructDecorateCodes.map(code=>{
      let data = {
        decorateCode:code,
        decorateName:this.decorateMap[code]
      }
      return data
    })
    const execDecorateKey = Object.keys(this.execDecorateMap).filter(key =>{
      return this.itemKey.startsWith(key)
    })
    const execDecorateCodes = this.execDecorateMap[execDecorateKey[0]].split('|')
    this.showExecDecorates = execDecorateCodes.map(code=>{
      let data = {
        decorateCode:code,
        decorateName:this.decorateMap[code]
      }
      return data
    })
    //this.showDecorates = this.themeConfig.showDecorates || []
    //this.showExecDecorates = this.themeConfig.showExecDecorates || []
    if(this.showDecorates.length>0){
      this.showDecorates.forEach(item=>{
        if(item.decorateName.startsWith('店内')) this.showDecoratesInner.push(item)
        else if(item.decorateName.startsWith('店外')) this.showDecoratesOuter.push(item)
        else this.showDecoratesOther.push(item)
      })
    }
    if(this.isHQ) this.assignCodeList = this.buList || []
    else if(this.isBU) this.assignCodeList = this.regionList || []
    else if(this.isRegion) this.assignCodeList = this.regionOrgList || []
    this.assignInfoList =  this.assignCodeList.map(assignItem=>{
      let data = {
        orgName:assignItem.orgName,
        orgCode:assignItem.orgCode,
        assignQty:'',
        srcAssignId:0,
        m3List:assignItem.m3List || [],
        executorList:[],
        executorCodeList:[],
        saveAssignQty:0
      }
      return data
    })
    if(Object.keys(this.saveInfo).length>0){
      if(Object.keys(this.saveInfo.themeDetail).length!==0){
        for(let key in this.params){
          this.params[key] = this.saveInfo.themeDetail[key]
        }
      }
      //console.log(this.saveInfo);
      if(this.saveInfo.subAssignList){
        //this.assignId = this.saveInfo.subAssignList[0].assignId
        let key
        if(this.isHQ) key ='buCode'
        else if(this.isBU) key='regionCode'
        else if(this.isRegion) key='regionCode'
        this.assignList = this.saveInfo.subAssignList.map(item=>{
          return item[key]
        })
        this.assignInfoList.forEach(assignItem=>{
          const listName = this.isRegion?'curAssignList':'subAssignList'
          this.saveInfo[listName].forEach(savedItem=>{
            if(savedItem[key]===assignItem.orgCode){
              assignItem.assignQty = savedItem.assignQty
              assignItem.assignId = savedItem.assignId
              assignItem.saveAssignQty = savedItem.assignQty
              assignItem.regionAssignList = savedItem.regionAssignList
              assignItem.submitCountQty = savedItem.submitCountQty
            }
          })
        })
      }
      if(this.saveInfo.executorList){
        this.assignInfoList.forEach(assignItem=>{
          this.saveInfo.executorList.forEach(savedItem=>{
            if(savedItem.buCode===assignItem.orgCode){
              assignItem.executorCodeList.push(savedItem.executorCode)
              assignItem.executorList.push(savedItem)
            }
          })
        })
      }
      // 获取装饰点位数据
      this.themeDecorateCodes = this.saveInfo.themeDetail.themeDecorateCodes || []
      // this.showDecorates.forEach(item=>{
      //   const isChecked = themeDecorateCodes.indexOf(item.decorateCode)!==-1
      //     if(isChecked) this.themeDecorateCodes.push(item.decorateCode)
      // })
      // this.showExecDecorates.forEach(item=>{
      //   const isChecked = themeDecorateCodes.indexOf(item.decorateCode)!==-1
      //     if(isChecked) this.themeExecDecorates.push(item.decorateCode)
      // })
    }
    this.params.pocRelateType = this.themeConfig.pocRelateType
  },
  mounted(){
    this.$refs.editFormRef.resetFields()
    this.$nextTick(() => {
      //this.processSpecialDecorateCtl()
    })
  },
  methods: {
    handleChangeAssignQty(item,val){
      if(val<this.getMinAssign(item)) {
        this.$message.error(`额度分配不可小于${this.isHQ?'已下发':'已提报'}`)
        item.assignQty = item.saveAssignQty
      }
    },
    getMinAssign(item){
      if(this.isHQ) return this.getNextAssignQty(item.regionAssignList)||0
      else return this.getNextAssignQty(item.regionAssignList,item.submitCountQty)||0
    },
    submitData(){
      let subAssignList = this.assignInfoList.filter(assignItem=>{
          //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
        return this.assignList.indexOf(assignItem.orgCode)!==-1
      })
      let themeDetail=this.params
      this.configInfo.themeStyleCode?themeDetail.themeStyleCode = this.configInfo.themeStyleCode:''
      this.configInfo.themeLevelCode?themeDetail.themeLevelCode = this.configInfo.themeLevelCode:''
      this.themeConfig.pocRelateType !== 2 ? themeDetail.pocCountMin = this.themeConfig.pocRelateType :''
      themeDetail.themeChannelCode = this.themeChannelCode
      //themeDetail.decorateCode = this.themeDecorateCodes.join(',')
      //themeDetail.execDecorateCode = this.themeExecDecorates.join(',')
      if(Object.keys(this.saveInfo).length>0&&this.saveInfo.themeDetail.themeDetailId) themeDetail.themeDetailId = this.saveInfo.themeDetail.themeDetailId
      //let subAssignValid = true
      let detailValid = true

      const validateData = this.getValidateResult(themeDetail)
      detailValid = validateData.isValid
      let errorMessage = validateData.errorMessage
      if(detailValid){
        if(subAssignList.length===0) {
          detailValid = false
          !errorMessage?errorMessage = `"${this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')}"未添加额度配置`:''
        }else {
          subAssignList.forEach(item=>{
            if(item.assignQty===''){
              detailValid = false
              !errorMessage?errorMessage = `"${this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')}-${this.getName(item.orgName)}"额度未分配`:''
            }
            if(this.isHQ && item.executorList.length===0){
              detailValid = false
              !errorMessage?errorMessage = `"${this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')}-${this.getName(item.orgName)}"未选择执行人`:''
            }
          })
          // subAssignList.forEach(item=>{
          //   if(item.executorList.length===0){
          //     detailValid = false
          //     !errorMessage?errorMessage = `"${this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')}-${this.getName(item.orgName)}"未选择执行人`:''
          //   }
          // })
        }
      }
      // if(themeDetail.needConstruct===1){
      //   if(this.themeDecorateCodes.length===0) isValid =  false
      // }
      // if(themeDetail.needSpr===1){
      //   if(this.themeExecDecorates.length===0) isValid =  false
      // }
      if(this.params.themeDecorateCodes&&this.params.themeDecorateCodes.length>0) {
        themeDetail.decorateScope = this.params.themeDecorateCodes.join(',')
        this.themeDecorates = []
        this.themeDecorateCodes.forEach(code=>{
          this.showDecorates.forEach(item=>{
            if(item.decorateCode===code){
              this.themeDecorates.push(item)
            }
          })
          this.showExecDecorates.forEach(item=>{
            if(item.decorateCode===code){
              this.themeDecorates.push(item)
            }
          })
        })
      }
      else themeDetail.decorateScope=''
      const styleName = this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')
      let data = {
        subAssignList,
        themeDetail,
        errorMessage,
        isValid:detailValid,
        styleName,
        themeDecorates:this.themeDecorates
      }
      this.$emit('submitDetail',data,this.itemKey)
    },
    getValidateResult(themeDetail){
      let isValid = true
      let errorMessage = ''
      const styleName = this.configInfo.themeStyleName+(this.configInfo.themeLevelName?'-'+this.configInfo.themeLevelName:'')
      if(!themeDetail.themeDecorateCodes||themeDetail.themeDecorateCodes.length===0) {
        isValid =  false
        errorMessage = `"${styleName}"未选择点位照片`
      }else if(!themeDetail.investUnit){
        isValid = false
        errorMessage = `"${styleName}"未填写单场投入预算`
      }else if(themeDetail.needTransitions===1&&!Number(themeDetail.itemQuantity)){
        isValid = false
        errorMessage = `"${styleName}"未设置道具数量`
      }else if(themeDetail.needTransitions===0&&!Number(themeDetail.perExecDays)){
        isValid = false
        errorMessage = `"${styleName}"未填写每活动地点执行活动天数`
      }else if(themeDetail.needSpr===1&&(!themeDetail.pgQtyLimit||themeDetail.needPerformance===null||themeDetail.needPerformance==='')){
        isValid = false
        errorMessage = `"${styleName}"需要使用SPR临促管理系统，须填写"临促人员人数限制"，选择"打卡/执行信息上传方式"`
      }else if (themeDetail.needSpr===1&&(this.themeDecorateCodes.indexOf('101')===-1&&this.themeDecorateCodes.indexOf('109')===-1)){
        isValid = false
        errorMessage =`"${styleName}"需要使用SPR临促管理系统选择是，点位照片需选择"促销员打卡"或"演绎人员打卡"`
      }else if (themeDetail.pocRelateType==2&&!themeDetail.pocCountMin){
        isValid = false
        errorMessage =`"${styleName}"未填写最少关联售点设置`
      }
      let data = {
        isValid,
        errorMessage
      }
      return data
    },
    handleDecorateCodesChange(){
      this.params.themeDecorateCodes = this.themeDecorateCodes || []
    },
    getAssignQty(assignQty){
      if(assignQty){
        return `${this.params.needTransitions?assignQty:assignQty*this.params.perExecDays}`
      }
    },
    handleDeleteAssign(item){
      if(this.getMinAssign(item)>0) {
        this.$message.error(`该区域${this.isHQ?'已下发':'已提报'},不可删除`)
        return 
      }
      this.assignList = this.assignList.filter(selectedItem=>{
        return selectedItem!==item.orgCode
      })
      this.handleChangeAssignList()
    },
    handleChangeAssignList(){
      this.assignInfoList.forEach(assignItem=>{
        const isSelected = this.assignList.indexOf(assignItem.orgCode)!==-1
        if(!isSelected){
          assignItem.assignQty=''
          assignItem.executorList=[]
          assignItem.executorCodeList=[]
        }
      })
    },
    handleSelectExecutor(buItem){
      buItem.executorList = []
      buItem.m3List.forEach(item=>{
        if(buItem.executorCodeList.indexOf(item.employeeCode)!==-1){
          const data = {
            buCode:buItem.orgCode,
            executorCode:item.employeeCode,
            themeId:this.themeId,
            themeDetailId:this.configInfo.saveInfo&&this.configInfo.saveInfo.themeDetail.themeDetailId||null,
            executorName:item.clientName
          }
          buItem.executorList.push(data)
        }
      })
    },
    handleSelectExecutorList(){
      // if(this.validDetailKey){
      //   this.$confirm(`是否确定复制?`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     confirmButtonClass: 'btn-red',
      //     type: 'warning'
      //   })
      //   .then(() => {
          this.assignList = []
          this.assignList = this.validDetail[this.validDetailKey].subAssignList.map(item=>{
            return item.orgCode
          })
          this.assignInfoList.forEach((bu,index)=>{
            let isSelected = false
            let info = {}
            this.validDetail[this.validDetailKey].subAssignList.forEach(selected=>{
              if(bu.orgCode===selected.orgCode){
                isSelected = true
                info = Object.assign({},selected)
                const executorCodeList = Object.assign([],selected.executorCodeList)
                const executorList = selected.executorList.map(executor=>{
                  const data = {
                    buCode:bu.orgCode,
                    executorCode:executor.executorCode,
                    themeId:this.themeId,
                    themeDetailId:this.configInfo.saveInfo&&this.configInfo.saveInfo.themeDetail.themeDetailId||null,
                    executorName:executor.executorName
                  }
                  return data
                })
                info = {
                  executorCodeList,
                  executorList,
                  assignQty:selected.assignQty
                }
              }
            })
            if(isSelected){
              bu.executorCodeList = info.executorCodeList
              bu.executorList = info.executorList
              bu.assignQty= info.assignQty
            }else {
              bu.assignQty = ''
              bu.executorList=[],
              bu.executorCodeList=[]
            }
          })
        // })
        // .catch(() => {})
        // }
    },
    processSpecialDecorateCtl() {
      //console.log('processSpecialDecorateCtl')
      // 人工照片类型20需要特殊处理，当需要搭建为1时，强制必选
      const decorateWorkPhoto = '20'
      const decorateIndex = this.showDecorates.findIndex(item => {
        return item.decorateCode === decorateWorkPhoto
      })
      //console.log(decorateIndex)
      if (decorateIndex > -1) {
        const decorateObj = this.showDecorates[decorateIndex]
        decorateObj.mandatory = this.params.needConstruct === 1
        this.showDecorates.splice(decorateIndex, 1, decorateObj)
        if (this.params.needConstruct === 1) {
          if (this.params.themeDecorateCodes.indexOf(decorateWorkPhoto) < 0) {
            this.params.themeDecorateCodes.push(decorateWorkPhoto)
          }
        }else {
          let index = this.params.themeDecorateCodes.indexOf(decorateWorkPhoto)
          if( index > -1 ) {
            this.params.themeDecorateCodes.splice(index,1)
          }
        } 
      }
    },
    onNeedConstructChanged() {
      //this.processSpecialDecorateCtl()
    },
    needTransitionsChanged(){
      if(this.params.needTransitions===0){
        this.$refs.perExecDaysRef.resetField()
      }else {
        this.$refs.itemQuantityRef.resetField()
      }
      this.params.perExecDays = ''
      this.params.itemQuantity = ''
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    handleValidatePocCountMin(){
      if(Number(this.params.pocCountMin)<1){
        this.params.pocCountMin=''
        return this.$message.error('最小售点数需大于等于1')
      }
    },
    validateSubmit() {
      this.$refs.editFormRef.validate(valid=>{
        
      })
    },
    validateSubmit1() {
      //console.log(this.$refs.editFormRef);
      this.$refs.assignFormRef.validate(valid=>{
      })
    },
    getNextAssignQty(list,submitCountQty){
      if(this.isBU||this.isRegion){
        return submitCountQty || 0
      }else if(this.isHQ&&list){
        let assignQty = list.reduce((pre,item)=>{
          return pre + Number(item.assignQty)
        },0)
        return assignQty || 0
      }
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return 0
    },
    getDifferenceValue(first,second){
      return Number(first) - Number(second)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox.is-checked .el-checkbox__inner::after {
  border-color: #a5a5a5;
}
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #DCDFE6 !important;
}
.font-red{
  color: rgb(226, 0, 0);
}
.required-text{
  color: red;
  margin:0 2px 0 -9px;
}
.sp-icon{
  margin:0px 0 0 5px;
  text-align: center;
  font-size: 16px;
  color: #b3b0b0;
  cursor: pointer;
}
.decorateCodes{
  display: flex;
}
.normal_box{
  padding-left: 30px;
}
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom:12px;

  .el-form-item__label {
    color: black;
    font-weight: 600;
    margin-left:3px;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .el-input__inner {
  width: 200px !important;
}
::v-deep .input-width-sp .el-input__inner {
  width: 155px;
}
::v-deep .el-select {
  margin: 0 20px 0px 0;
}
.el-form-item{
  width: 100%;
}
.sp-el-form{
  width: 75%;
  position: relative;
  left: 180px;
  margin-top: -65px;
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item__error{
  width: 150px;
}


::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    margin-left: -10px;
}

::v-deep .el-select__tags {
  display: flex;
  flex-wrap: nowrap !important;
  //height: 35px;
  overflow: hidden;
}

// 额度分配
::v-deep .assign-box .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
::v-deep .assign-box .el-form-item {
  display: flex;
  flex-direction: column;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin:-5px 0 5px 0;
}
// 装饰点位 默认选中 灰色样式
// ::v-deep .sp .el-checkbox__input.is-checked .el-checkbox__inner,.sp .el-checkbox__input.is-indeterminate .el-checkbox__inner{
//     background-color: #b5b5b5 !important;
//     border-color: #b5b5b5 !important;
// }
// ::v-deep .sp .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
//     border-color: #ffffff !important;
//     color: #606266 !important;
// }
// ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
//   color: #606266 !important;
// }
.el-checkbox{
  margin-right: 20px;
}
.decorate-style{
  width: 750px;
  display:flex;
  flex-wrap: wrap;
}
.config-detail-bu{
  margin-left:180px;
}
.assign-detail{
  display:flex;
}
::v-deep .assign-executor .el-input__inner{
  width:200px !important;
}
::v-deep .config-detail-bu .required-text{
  margin-left:0;
}
::v-deep .config-detail-bu .el-form-item{
  margin-bottom:0px !important;
}
.assign-title-box{
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.assign-title-delete{
  margin-right:10px;
  cursor:pointer;
  font-size:20px;
  color:rgb(226, 0, 0);
}
::v-deep .el-form-title-select .el-input__inner{
  width:92px !important;
}
::v-deep .el-form-title-select .el-select{
  margin-right:0px !important;
}
.assign-num-box {
  margin-top:10px;
  div{
    line-height:25px;
  }
}
.color-red{
  color:rgb(226, 0, 0);
}
.color-green{
  color:rgba(0, 223, 30, 0.733);
}
</style>
